var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "category-filter-wrapper" }, [
    _c(
      "ul",
      { staticClass: "category-filter-list" },
      _vm._l(_vm.filters, function (filter) {
        return _c(
          "li",
          { key: filter, staticClass: "category-filter-list-item" },
          [
            _c("category-filter", {
              attrs: {
                label: filter,
                icon: filter,
                filterValue: filter,
                clearSelectedFilters: _vm.clearSelectedFilters,
              },
              on: { change: _vm.handleFilterChange },
              model: {
                value: _vm.checkedFilter,
                callback: function ($$v) {
                  _vm.checkedFilter = $$v
                },
                expression: "checkedFilter",
              },
            }),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }